export default {
  title: {
    id: 'review_ai_summary_title',
    defaultMessage: 'What our customers say about {productName}',
  },
  caption: {
    id: 'review_ai_summary_caption',
    defaultMessage: 'AI generated',
  },
} as const
